import PlaceVertical from "./PlaceVertical.page";

export default PlaceVertical;
